import { render, staticRenderFns } from "./ServiceCharge.vue?vue&type=template&id=5e9de494&scoped=true&"
import script from "./ServiceCharge.vue?vue&type=script&lang=js&"
export * from "./ServiceCharge.vue?vue&type=script&lang=js&"
import style0 from "./ServiceCharge.vue?vue&type=style&index=0&id=5e9de494&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e9de494",
  null
  
)

export default component.exports